import PurchaseOrderLineItemRow from "./PurchaseOrderLineItemRow";

export default function PurchaseOrderLineItemsTable({
  lineItems = [],
  assemblyItemOptions,
  onLineItemAssemblySelect,
  updateLineItem,
  removeLineItem,
  addLineItem,
}) {
  return (
    <section className="rounded-2xl border border-[#E2E8F0] bg-white p-5 shadow-sm">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h2 className="text-base font-semibold text-[#0F172A]">
            Ordered items
          </h2>
          <p className="mt-1 text-sm text-[#64748B]">
            Add the raw materials, ingredients, packaging, or supplier items
            expected from this vendor.
          </p>
        </div>
        <button
          type="button"
          className="inline-flex h-10 shrink-0 items-center justify-center rounded-xl border border-[#2563EB] bg-white px-4 text-sm font-semibold text-[#2563EB] transition hover:bg-[#EFF6FF]"
          onClick={addLineItem}
        >
          + Add item
        </button>
      </div>

      {lineItems.length === 0 ? (
        <div className="mt-8 rounded-xl border border-dashed border-[#CBD5E1] bg-[#F8FAFC] px-6 py-10 text-center">
          <p className="text-sm font-medium text-[#0F172A]">
            No items added yet.
          </p>
          <p className="mt-1 text-sm text-[#64748B]">
            Add the materials you expect to receive from this supplier.
          </p>
          <button
            type="button"
            className="mt-4 inline-flex h-10 items-center justify-center rounded-xl bg-[#2563EB] px-4 text-sm font-semibold text-white hover:bg-[#1D4ED8]"
            onClick={addLineItem}
          >
            Add first item
          </button>
        </div>
      ) : (
        <div className="mt-5 overflow-x-auto">
          <table className="po-line-items-table min-w-[980px] w-full text-left text-sm">
            <thead>
              <tr className="border-b border-[#E2E8F0] bg-[#EFF6FF] text-[11px] font-semibold uppercase tracking-wide text-[#64748B]">
                <th className="px-3 py-2">Item</th>
                <th className="px-3 py-2">Ordered qty</th>
                <th className="px-3 py-2 text-right">Received</th>
                <th className="px-3 py-2 text-right">Fulfillment</th>
                <th className="px-3 py-2 text-center">UOM</th>
                <th className="px-3 py-2">Unit cost</th>
                <th className="px-3 py-2 text-right">Subtotal</th>
                <th className="px-3 py-2 text-right">Tax</th>
                <th className="px-3 py-2 text-right">Line total</th>
                <th className="px-3 py-2 text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {lineItems.map((row) => (
                <PurchaseOrderLineItemRow
                  key={row.temp_id}
                  row={row}
                  assemblyItemOptions={assemblyItemOptions}
                  onAssemblySelect={onLineItemAssemblySelect}
                  updateLineItem={updateLineItem}
                  onRemove={removeLineItem}
                />
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
